import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import IMetadataType from '../../../app/_interfaces/IMetadataType';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetadataTypesService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<IMetadataType[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/metadata-types`
    );
  }

  create(task: IMetadataType) {
    return this.http.post<IMetadataType>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/metadata-types`,
      task
    );
  }

  delete(task: IMetadataType) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/metadata-types/${task.id}`
    );
  }
}
